<h2 mat-dialog-title>Neuen Realm anlegen</h2>
<mat-dialog-content class="mat-typography">
  <h3>Hier können Sie einen neuen Realm erstellen</h3>

  @if (isLoading()) {
    <div class="create-realm-loading-container">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <form [formGroup]="settingsFormGroup" class="create-realm-container">
      <mat-form-field>
        <mat-label>Realm & Tenant Identifier</mat-label>
        <input
          matInput
          type="text"
          formControlName="realmAndTenantIdentifier"
          required
        />
        @if (settingsFormGroup.controls.realmAndTenantIdentifier.invalid) {
          <mat-error>{{ requiredErrorMessage }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Firmen Anzeigename</mat-label>
        <input matInput type="text" formControlName="displayName" required />
        @if (settingsFormGroup.controls.displayName.invalid) {
          <mat-error>{{ requiredErrorMessage }}</mat-error>
        }
      </mat-form-field>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="warn" [disabled]="isLoading()">
    Abbrechen
  </button>
  <button
    mat-button
    color="primary"
    (click)="createRealmClicked()"
    [disabled]="settingsFormGroup.invalid || isLoading()"
  >
    Erstellen
  </button>
</mat-dialog-actions>
